export {
  default 
} from "./newsletter";
